/**
 * DevExtreme (esm/__internal/pagination/editors/common/editor_label_props.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { current, isMaterial } from "../../../../ui/themes";
export const EditorLabelDefaultProps = {
  label: "",
  labelMode: isMaterial(current()) ? "floating" : "static"
};